<template>
    <component :is="component" v-if="component" :awardList="awardList"></component>
</template>

<script>
export default {
    name: "AwardListLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        listLayout: '',
        awardList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.loader()
            .then(() => {
                this.component = () => this.loader()
            })
            .catch(() => {
                this.component = () => import('@/template/award/list/AwradListDefaultLayout')
            })

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.listLayout) {
                return null
            }
            return () => import(`@/template/award/list/${this.listLayout}`)
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
